var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSweden(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 1000,
    viewBox: "0 0 16 10",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    fill: "#006aa7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    x: 5,
    fill: "#fecc00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    y: 4,
    fill: "#fecc00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE2MDAiIGhlaWdodD0iMTAwMCIgdmlld0JveD0iMCAwIDE2IDEwIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjEwIiBmaWxsPSIjMDA2YWE3Ii8+CjxyZWN0IHdpZHRoPSIyIiBoZWlnaHQ9IjEwIiB4PSI1IiBmaWxsPSIjZmVjYzAwIi8+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIyIiB5PSI0IiBmaWxsPSIjZmVjYzAwIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };